<ng-template #content let-modal>
  <ng-container *ngIf="pdfFileUrl">
    <ng-container *ngIf="!imageMode">
      <div class="h-100 w-100 position-relative">
        <button
          (click)="downloadResource(proxyUrl + pdfFileUrl)"
          class="file-download-button lty-btn lty-btn-white d-flex"
        >
          <app-download-icon
            height="20px"
            width="20px"
            color="var(--gray-500)"
          />
        </button>
        <pdf-viewer
          [src]="proxyUrl + pdfFileUrl"
          [render-text]="true"
          style="width: 100%; height: 500px; max-height: 80vh"
          [autoresize]="true"
        />
      </div>
    </ng-container>
    <ng-container *ngIf="imageMode">
      <img
        [src]="pdfFileUrl"
        style="width: 100%; height: auto; max-height: 80vh"
      />
    </ng-container>
  </ng-container>
</ng-template>
